import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7c05660"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-profile" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_Image = _resolveComponent("Image")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_DxpOmsInstanceNavigator = _resolveComponent("DxpOmsInstanceNavigator")!
  const _component_DxpFacilitySwitcher = _resolveComponent("DxpFacilitySwitcher")!
  const _component_DxpAppVersionInfo = _resolveComponent("DxpAppVersionInfo")!
  const _component_DxpProductIdentifier = _resolveComponent("DxpProductIdentifier")!
  const _component_DxpTimeZoneSwitcher = _resolveComponent("DxpTimeZoneSwitcher")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_menu_button, {
                "data-testid": "settings-page-menu-btn",
                slot: "start"
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("Settings")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { "data-testid": "settings-page-content" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, { lines: "full" }, {
                  default: _withCtx(() => [
                    (_ctx.userProfile?.partyImageUrl)
                      ? (_openBlock(), _createBlock(_component_ion_avatar, {
                          key: 0,
                          slot: "start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Image, {
                              src: _ctx.userProfile.partyImageUrl
                            }, null, 8, ["src"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_card_header, { class: "ion-no-padding ion-padding-vertical" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_subtitle, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userProfile.userLoginId), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userProfile.partyName), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_ctx.authStore.isEmbedded)
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 0,
                      "data-testid": "settings-page-logout-btn",
                      color: "danger",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Logout")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.authStore.isEmbedded)
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 1,
                      "data-testid": "settings-page-launchpad-btn",
                      "standalone-hidden": !_ctx.hasPermission(_ctx.Actions.APP_PWA_STANDALONE_ACCESS),
                      fill: "outline",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToLaunchpad()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Go to Launchpad")) + " ", 1),
                        _createVNode(_component_ion_icon, {
                          slot: "end",
                          icon: _ctx.openOutline
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["standalone-hidden"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.translate('OMS')), 1)
          ]),
          _createElementVNode("section", null, [
            _createVNode(_component_DxpOmsInstanceNavigator),
            _createVNode(_component_DxpFacilitySwitcher, { onUpdateFacility: _ctx.updateFacility }, null, 8, ["onUpdateFacility"])
          ]),
          _hoisted_3,
          _createVNode(_component_DxpAppVersionInfo),
          _createElementVNode("section", null, [
            _createVNode(_component_DxpProductIdentifier),
            _createVNode(_component_DxpTimeZoneSwitcher, { onTimeZoneUpdated: _ctx.timeZoneUpdated }, null, 8, ["onTimeZoneUpdated"]),
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Force scan")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, { innerHTML: _ctx.barcodeContentMessage }, null, 8, ["innerHTML"]),
                _createVNode(_component_ion_item, {
                  disabled: !_ctx.hasPermission(_ctx.Actions.APP_UPDT_FULFILL_FORCE_SCAN_CONFIG)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_toggle, {
                      "data-testid": "settings-page-force-scan-toggle",
                      "label-placement": "start",
                      checked: _ctx.isForceScanEnabled,
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.updateForceScanStatus($event)), ["prevent"]))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Require scanning")), 1)
                      ]),
                      _: 1
                    }, 8, ["checked"])
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_ion_item, { lines: "none" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_select, {
                      "data-testid": "settings-page-barcode-identifier-select",
                      label: _ctx.translate('Barcode Identifier'),
                      interface: "popover",
                      placeholder: _ctx.translate('Select'),
                      value: _ctx.barcodeIdentificationPref,
                      onIonChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setBarcodeIdentificationPref($event.detail.value)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.barcodeIdentificationOptions, (identification) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            "data-testid": `settings-page-barcode-option-${identification.goodIdentificationTypeId}`,
                            key: identification,
                            value: identification.goodIdentificationTypeId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(identification.description ? identification.description : identification.goodIdentificationTypeId), 1)
                            ]),
                            _: 2
                          }, 1032, ["data-testid", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["label", "placeholder", "value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Receive flow type")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate("Define the receiving flow for TO items")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, {
                  disabled: !_ctx.hasPermission(_ctx.Actions.APP_UPDT_RECEIVE_FLOW_CONFIG)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_toggle, {
                      "data-testid": "settings-page-receive-flow-toggle",
                      "label-placement": "start",
                      checked: _ctx.isReceivingByFulfillment,
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.updateReceiveFlowType($event)), ["prevent"]))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Receive by fulfillment")), 1)
                      ]),
                      _: 1
                    }, 8, ["checked"])
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}